module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ab157-cb1e04ed9789a54eef324d229456e1c1.jpg";